<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    :width="width" :height="height" viewBox="0 0 234.000000 137.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,137.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path d="M2035 1279 c-11 -6 -49 -50 -85 -99 -36 -50 -66 -90 -68 -90 -1 0 4
      13 12 29 l15 29 -60 -36 -60 -36 2 -51 c2 -49 -1 -56 -54 -126 -32 -41 -95
      -119 -142 -174 -47 -55 -92 -115 -101 -134 -15 -30 -15 -35 0 -49 15 -15 21
      -14 73 12 32 16 85 37 118 48 93 29 122 77 148 241 l14 87 89 115 c49 64 102
      135 117 158 39 60 30 99 -18 76z"/>
      <path d="M382 578 c-17 -17 -15 -45 3 -52 23 -8 45 4 45 25 0 24 -33 42 -48
      27z"/>
      <path d="M14 566 c-3 -8 -4 -97 -2 -198 3 -167 5 -187 25 -225 29 -52 75 -88
      134 -103 64 -16 104 -10 104 15 0 16 -9 21 -54 28 -72 10 -109 33 -135 82 -19
      36 -21 60 -24 228 -3 178 -5 187 -23 187 -11 0 -22 -6 -25 -14z"/>
      <path d="M652 459 c-91 -46 -114 -109 -110 -294 3 -124 4 -130 25 -133 21 -3
      21 0 25 145 3 132 5 152 25 184 55 88 183 89 240 2 15 -22 19 -56 23 -177 5
      -147 6 -151 28 -154 22 -3 22 -3 22 149 0 133 -3 158 -20 195 -45 91 -166 130
      -258 83z"/>
      <path d="M1047 473 c-15 -14 -4 -34 68 -124 44 -55 71 -97 66 -104 -4 -5 -40
      -50 -80 -99 -40 -48 -70 -93 -68 -100 2 -6 12 -12 23 -13 13 -2 39 23 89 87
      39 49 73 89 76 89 3 1 38 -39 77 -89 40 -49 79 -90 88 -90 36 0 22 33 -50 123
      -42 52 -76 98 -76 102 0 4 34 50 76 102 72 90 86 123 50 123 -9 0 -48 -40 -88
      -90 -39 -49 -74 -90 -77 -90 -3 1 -37 41 -75 90 -64 84 -83 100 -99 83z"/>
      <path d="M381 436 c-8 -9 -11 -73 -9 -207 3 -181 4 -194 22 -197 10 -2 22 2
      27 10 14 21 11 382 -3 396 -15 15 -23 15 -37 -2z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "VtexSvg",
  props: ["width", "height"]
}
</script>